/**
 * This setting stores a list of layoutElement.onClickEventName which we would want to have styling on for
 * the Markets showtime homepage.
 * Product Area: LOGGED_IN_HOMEPAGE
 */
export const FAIRE_MARKET_STYLED_HOMEPAGE_ONCLICKEVENTNAME = 'FAIRE_MARKET_STYLED_HOMEPAGE_ONCLICKEVENTNAME';
